import '@/scss/taxonomy/category/category.scss';
import {loadMore} from "@/js/taxonomy/category/components/loadMore";

loadMore();